var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkSimple = function SvgLinkSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m5.468 9.47 4-4a.751.751 0 1 1 1.063 1.062l-4 4A.751.751 0 0 1 5.468 9.47m8.188-7.125a3.755 3.755 0 0 0-5.304 0l-1.883 1.88a.751.751 0 1 0 1.063 1.063L9.41 3.409a2.25 2.25 0 0 1 3.183 3.183L10.712 8.47a.75.75 0 0 0 .531 1.282.75.75 0 0 0 .532-.22l1.88-1.878a3.755 3.755 0 0 0-.002-5.307zM8.47 10.712l-1.88 1.88a2.252 2.252 0 0 1-3.842-1.591c0-.597.238-1.17.66-1.592l1.879-1.88a.752.752 0 0 0-1.063-1.062L2.347 8.35a3.751 3.751 0 0 0 5.305 5.304l1.878-1.88a.751.751 0 0 0-1.062-1.062z"
  })));
};
export default SvgLinkSimple;